import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { SectionBase } from 'pages/conversations/pages/search/ui/Results/ui/SectionBase/SectionBase'
import { MessageCard } from 'pages/conversations/pages/search/ui/Results/ui/MessageCard/MessageCard'
import { useResultsContext } from 'pages/conversations/pages/search/ui/Results/context/resultsContext'
import { logV2SearchEvent } from 'pages/conversations/pages/search/utils/logSearchEvent'

export const SectionMessages = observer(() => {
  const entities = useEntitiesContext()
  const { resultsMessagesStore, setActiveTab, handleGoToProfile } = useResultsContext()
  const { items, loading, hasItems } = resultsMessagesStore

  return (
    <SectionBase
      title={'Messages'}
      loading={loading}
      notResult={!hasItems}
      notResultTitle={'No messages found'}
      linkTitle={'View all messages'}
      onClickLinkTitle={() => {
        setActiveTab('messages')

        logV2SearchEvent(
          'Search Page Result Clicked',
          {
            event_id: 'search_page_result_clicked',
            SearchResultClickedType: 'View all Messages',
          },
          entities
        )
      }}
    >
      {items.map((item) => {
        return (
          <MessageCard
            key={item.id}
            item={item}
            onActionClick={(item) => {
              handleGoToProfile(item)

              logV2SearchEvent(
                'Search Page Result Clicked',
                {
                  event_id: 'search_page_result_clicked',
                  SearchResultClickedType: 'Message_top_results',
                },
                entities
              )
            }}
          />
        )
      })}
    </SectionBase>
  )
})
